import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import styles from './PricingContactLine.module.scss';

const SALES_URL = 'mailto:sales@music24.com';

const messages = defineMessages({
  contact: { id: 'app.sml.pricing.contact', defaultMessage: 'Have more needs or more artists to manage? {link}' },
  contactLink: { id: 'app.sml.pricing.contact.link', defaultMessage: 'Contact us' },
});

/**
 * The line right under the paid cards (owner, 2026-10-23; the website says the same): a customer
 * with more needs, or with more artists than a plan sells, writes to sales. It replaces the old
 * enterprise line at the end of the page.
 */
const PricingContactLineComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <p className={styles.contact} data-testid="pricing-contact">
      {intl.formatMessage(messages.contact, {
        link: (
          <a key="sales" href={SALES_URL}>
            {intl.formatMessage(messages.contactLink)}
          </a>
        ),
      })}
    </p>
  );
};

export const PricingContactLine = TypedMemo(PricingContactLineComponent);
